import React  , {forwardRef} from 'react';
import { GoogleMapsProvider } from '../../../components/GoogleMapsProvider';
import Locations from './Locations';

// function LocationMap() {
//     return (
//         <>
//             <GoogleMapsProvider>
//                 <Locations />
//             </GoogleMapsProvider>
//         </>
//     );
// }

const LocationMap = forwardRef(({ onNext, onSuccess }, ref) => {
    return (
        <>
            <GoogleMapsProvider>
                <Locations onNext={onNext}  ref={ref}  onSuccess={onSuccess} />
            </GoogleMapsProvider>
        </>
    );
})

export default LocationMap;